<div class="container">
    <br />
    <div class="row g-0">
        <div class="col-lg-2">
            <img src="assets/images/logo.png" class="img-thumbnail" alt="LogoCamaraDiptuados" />
        </div>
        <div class="col-lg-10">

            <h2 style="text-align: center">
                Diputadas y diputados con licencia que van a reelección
            </h2>
            <p class="text-end text-muted">
                Total de registros <b>{{contendientes.length}}</b>
            </p>
        </div>
    </div>
    
    <div class="row">
        <div class="table-responsive">
        <table class="table">
            <thead class="table green">
                <tr>
                    <th class="enc_centrado" scope="col">N°</th>
                    <th class="enc_centrado" scope="col">Diputada / Diputado</th>
                    <th class="enc_centrado" scope="col">Grupo Parlamentario</th>
                    <th class="enc_centrado" scope="col">Entidad federativa</th>
                    <th class="enc_centrado" scope="col">Distrito / Circunscripción</th>
                    <th class="enc_centrado" scope="col">Tipo de elección</th>
                    <th class="enc_centrado" scope="col">Fecha de recepción</th>
                    <th class="enc_centrado" scope="col">En funciones</th>
                    <!-- <th class="enc_centrado" scope="col">Folio</th> -->
                    <th class="enc_centrado" scope="col">Documento</th>
                </tr>
            </thead>
            <tbody *ngFor="let c of contendientes; let i = index">
                <!-- *ngIf="c.EntidadFederativa === 'Ciudad de México'" -->
                <tr >
                    <td> {{ i + 1 }}</td>
                    <td>{{ c.NombreDiputado }}</td>
                    <td>{{ c.GrupoParlamentario }}</td>
                    <td>{{ c.EntidadFederativa }}</td>
                    <td>{{ c.DistritoCircuns }}</td>
                    <td>{{ c.TipoEleccion }}</td>
                    <td>{{ c.FechaRecepcion | date: "dd 'de' MMMM 'del' yyyy" }}</td>
                    <td>{{ c.EnFunciones }}</td>
                    <!-- <td>{{ c.Folio }}</td> -->
                    <td style="text-align: center;">
                        <a  class="btn btn-success" *ngIf="c.Enlace !== 0; else noFiles" 
                        href="{{c.SFTPDocumento2}}" target="_blank"
                        
                        >
                          
                        <i class="fas fa-file-download"></i>
                    </a>
                        <a href=""><button type="button" class="btn btn-success" *ngIf="c.NombreDiputado == 'Pérez Rivera Evaristo Lenin'; else noFiles" (click)="downloadBase64File(c)"></button></a>
                        <ng-template #noFiles>
                            <td></td>
                        </ng-template>
                    </td>
                </tr>
                <tr *ngIf="c.Notas !== null && c.Notas">
                    <td colspan="12">
                        <table class="table">
                            <thead class="table-light">
                                <tr>
                                    <td><b> Notas:</b> {{ c.Notas }}</td>
                                </tr>
                            </thead>
                            <!-- <tbody>
                                <tr>
                                    <td></td>
                                </tr>
                            </tbody> -->
                        </table>
                    </td>
                </tr>
            </tbody>
            <ng-template #loadingFiles>Cargando...</ng-template>
        </table>
    </div>
    </div>

</div>